import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input
} from '@angular/core';

import { CirrusInputDirective } from './directives/cirrus-input.directive';
import { InputPrefixDirective } from './directives/input-prefix.directive';
import { InputSuffixDirective } from './directives/input-suffix.directive';
import { LabelHelperDirective } from './directives/label-helper.directive';

@Component({
  selector: 'ls-cr-field-wrapper',
  templateUrl: './cirrus-field-wrapper.component.html',
  styleUrls: ['./cirrus-field-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CirrusFieldWrapperComponent implements AfterContentInit {
  @Input()
  public id: string;
  @Input()
  public label: string;
  @Input()
  public description: string;
  @Input()
  public textHelper: string;
  @Input()
  public disabled: boolean;
  @Input()
  public status: string;
  @Input()
  public className: string;
  @Input()
  public invalid = false;
  @Input()
  public size: 'small' | 'normal' | 'large' = 'normal';

  @Input() @ContentChild(LabelHelperDirective) public labelHelper:
    | LabelHelperDirective
    | string;

  @Input() @ContentChild(InputSuffixDirective) public suffix:
    | InputSuffixDirective
    | string;

  @Input() @ContentChild(InputPrefixDirective) public prefix:
    | InputPrefixDirective
    | string;

  @Input()
  @ContentChild(CirrusInputDirective)
  public inputDirective: CirrusInputDirective;

  public ngAfterContentInit(): void {
    const newClasses: Array<String> = [];
    if (this.prefix) {
      newClasses.push(`${this.inputDirective.baseClass}--has-prefix`);
    }
    if (this.suffix) {
      newClasses.push(`${this.inputDirective.baseClass}--has-suffix`);
    }
    if (this.status) {
      newClasses.push(`${this.inputDirective.baseClass}--status`);
      newClasses.push(`${this.inputDirective.baseClass}--${this.status}`);
    }
    this.inputDirective.className = newClasses.join(' ');
  }
}
